import React from 'react'

const Agencies = () => {
  return (
    <div>Agencies</div>
  )
}

export { Agencies }
